import { render, staticRenderFns } from "./VendorLanding.vue?vue&type=template&id=42256a3c"
import script from "./VendorLanding.vue?vue&type=script&lang=js"
export * from "./VendorLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports